/* network_discovery_flat.icon.svg.js */

module.exports = {
    icon: `    
<svg width="17" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="foreground-gl" d="M12.2422 0.930664C18.8696 0.930664 24.2422 6.30422 24.2422 12.9316C24.2419 19.5588 18.8694 24.9316 12.2422 24.9316C5.61506 24.9315 0.242451 19.5587 0.242188 12.9316C0.242188 6.30432 5.6149 0.930812 12.2422 0.930664ZM9.69336 9.10645H11.7646V12.1338H7.94043V16.1172H5.86914V19.3047H10.9678V16.1172H8.89648V13.0898H15.5889V16.1172H13.5176V19.3047H18.6152V16.1172H16.5439V12.1338H12.7207V9.10645H14.792V6.55762H9.69336V9.10645Z" fill="#29ABE2"/>
</svg>
`,
};
